import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  UserRound,
  Stethoscope,
  CalendarCheck,
  Globe,
  LogOut,
  Menu,
  X,
  ChevronRight,
  Activity,
} from 'lucide-react';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/doctors', icon: Stethoscope, label: 'Doctors' },
  { to: '/patients', icon: UserRound, label: 'Patients' },
  { to: '/appointments', icon: CalendarCheck, label: 'Appointments' },
  { to: '/countries', icon: Globe, label: 'Countries' },
];

export default function Layout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar */}
      <aside
        style={{
          width: sidebarOpen ? 240 : 70,
          background: 'var(--surface)',
          borderRight: '1px solid var(--border)',
          display: 'flex',
          flexDirection: 'column',
          transition: 'width 0.3s ease',
          flexShrink: 0,
          zIndex: 10,
          position: 'relative'
        }}
      >
        {/* Logo */}
        <div
          style={{
            padding: '20px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            borderBottom: '1px solid var(--border)',
            minHeight: 68,
          }}
        >
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              /* background:
                'linear-gradient(135deg, var(--accent), var(--accent2))', */
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <img src='/logo.jpg' width={40} height={40} />
          </div>
          {sidebarOpen && (
            <div>
              <div
                style={{
                  fontFamily: 'Syne',
                  fontWeight: 700,
                  fontSize: 18,
                  letterSpacing: '-0.02em',
                }}
              >
                Palav Neo Connect
              </div>
              {/* <div
                style={{
                  fontSize: 11,
                  color: 'var(--text3)',
                  marginTop: 1,
                }}
              >
                Admin Panel
              </div> */}
            </div>
          )}
        </div>

        {/* Toggle */}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{
            margin: '12px auto',
            width: 30,
            height: 30,
            borderRadius: 15,
            background: '#fff',
            border: '1px solid var(--border)',
            color: 'var(--text2)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            right: -18,
            top: 10
          }}
        >
          {sidebarOpen ? <X size={16} /> : <Menu size={16} />}
        </button>

        {/* Nav */}
        <nav
          style={{ flex: 1, padding: '4px 10px', overflowY: 'auto' }}
        >
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 12px',
                borderRadius: 10,
                marginBottom: 2,
                color: isActive ? 'white' : 'var(--text2)',
                background: isActive
                  ? 'linear-gradient(135deg, var(--accent), var(--accent2))'
                  : 'transparent',
                fontWeight: isActive ? 600 : 400,
                fontSize: 14,
                transition: 'all 0.15s',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              })}
            >
              {({ isActive }) => (
                <>
                  <Icon size={18} style={{ flexShrink: 0 }} />
                  {sidebarOpen && <span>{label}</span>}
                  {sidebarOpen && isActive && (
                    <ChevronRight
                      size={14}
                      style={{ marginLeft: 'auto' }}
                    />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Admin info + logout */}
        <div
          style={{
            padding: '14px 14px',
            borderTop: '1px solid var(--border)',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              background:
                'linear-gradient(135deg, var(--accent), var(--accent2))',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 13,
              fontWeight: 700,
              color: 'white',
              flexShrink: 0,
            }}
          >
            A
          </div>
          {sidebarOpen && (
            <>
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Admin
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: 'var(--text3)',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {admin?.email}
                </div>
              </div>
              <button
                onClick={handleLogout}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--text3)',
                  display: 'flex',
                  padding: 4,
                }}
                title="Logout"
              >
                <LogOut size={16} />
              </button>
            </>
          )}
        </div>
      </aside>

      {/* Main content */}
      <main
        style={{ flex: 1, overflow: 'auto', background: 'var(--bg)' }}
      >
        <div
          style={{
            padding: '32px',
            maxWidth: 1400,
            margin: '0 auto',
          }}
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
}
